import { api } from '../client';
import type { Group } from '../types';

interface ListParams {
  /** apenas admin/manager pode usar */
  all?: boolean;
  userId?: number;
}

/**
 * Endpoint /api/groups do Traccar. No vocabulário Fismatek, "Clientes".
 * Um Group é um agrupador de máquinas (geralmente um cliente final ou empresa).
 * Aceita hierarquia via `groupId` (parent group).
 */
export const groupsApi = {
  list: (params?: ListParams) => api.get<Group[]>('/groups', { query: params }),
  create: (group: Partial<Group>) => api.post<Group>('/groups', { body: group }),
  update: (id: number, group: Group) => api.put<Group>(`/groups/${id}`, { body: group }),
  delete: (id: number) => api.delete<void>(`/groups/${id}`),
};
